export default function Partners() {
  return (
    <section aria-label="Software partners" className="py-12 bg-white border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-center text-xs uppercase tracking-[0.18em] text-stone-500 font-semibold">
          Certified cloud accounting partners
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-5 md:gap-x-16">
          {/* Xero wordmark */}
          <div className="flex items-center gap-3 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition">
            <div className="h-12 w-12 rounded-full bg-[#13B5EA] grid place-items-center text-white font-bold text-lg">
              X
            </div>
            <span className="font-display text-xl font-semibold text-stone-700">Xero Partner</span>
          </div>
          {/* MYOB wordmark */}
          <div className="flex items-center gap-3 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition">
            <div className="h-12 px-3 rounded-lg bg-[#6100ED] grid place-items-center text-white font-bold tracking-wider">
              MYOB
            </div>
            <span className="font-display text-xl font-semibold text-stone-700">Certified Partner</span>
          </div>
          {/* IRD compliant pill */}
          <div className="flex items-center gap-3 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition">
            <div className="h-12 px-3 rounded-lg bg-stone-900 grid place-items-center text-white font-bold tracking-wider">
              IRD
            </div>
            <span className="font-display text-xl font-semibold text-stone-700">Registered Tax Agent</span>
          </div>
          {/* NZ Owned */}
          <div className="flex items-center gap-3 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition">
            <div className="h-12 px-3 rounded-lg bg-[#0b6b5b] grid place-items-center text-white font-bold tracking-wider">
              NZ
            </div>
            <span className="font-display text-xl font-semibold text-stone-700">Owned &amp; Operated</span>
          </div>
        </div>
      </div>
    </section>
  );
}
